module.exports = __webpack_public_path__ + "static/media/slide3.2e066b93.webp";